//#region IMPORT
import React, { useState, useRef, useEffect, useCallback } from 'react';
/** Services Import */
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
/** Components */
import { SCH_BASIC } from './index';
import { Loading } from '../../../../Components/MUIs';
import dayjs from 'dayjs';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
import useDateRange from '../../../../hooks/useDateRange';
import {
  useSearch1,
  useSearch2,
  useSearch3,
  useSearch4,
  useSearch5,
  useSearch6,
  useSave1,
  useSave2,
  useSave3,
  useSave4,
  useSave5,
  useDelete1,
  useDelete2,
  useDelete3,
} from './SCH_BASIC_QUERY';
//#endregion

//#region 상수
// 화면 MENU_ID
const SCREEN_MENU_ID = 'Schedule';
//#endregion

function SCH_BASICFunction() {
  //#region 변수
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { userInfo, lanInfo, menuInfo } = useSelector(
    (state) => state.BaseInfo
  );

  // 유저정보 배열로 구성되어 있어 첫 번재 요소 가져오도록 사용함 후에 지워야 할 수도 있음

  const gridRef1 = useRef(); //그리드 ref
  const [rowData1, setRowData1] = useState([]);
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);
  const [deletedRowData1, setDeletedRowData1] = useState([]);
  const selectedRowNosRef = useRef(new Set());
  const lastCheckedIndexRef = useRef(null);
  const currentRowIndexRef = useRef(null);
  const [codeList, setCodeList] = useState([]);
  const [dialog, setDialog] = useState({
    open: false,
    title: '',
    index: 0,
    actions: <></>,
  });
  // 내 캘린더
  const [modalToggle1, setModalToggle1] = useState(false);
  const [modalToggle2, setModalToggle2] = useState(false); // 캘린더 환경설정 팝업
  const [modalInputs, setModalInputs] = useState({
    startTime: dayjs().format('HH:mm'), //시작시간
    endTime: dayjs().format('HH:mm'), //종료시간
  });
  const [clickRowId, setClickRowId] = useState();

  // 캘린더 환경설정 관련 상태
  const [calendarManagementTab, setCalendarManagementTab] = useState(0); // 0: 내 캘린더, 1: 관심 캘린더
  const [favoriteCalendarView, setFavoriteCalendarView] =
    useState('myFavorites'); // 'myFavorites': 내가 등록한 관심 캘린더, 'viewingMe': 내 일정을 보고 있는 동료
  const [calendarManagementData, setCalendarManagementData] = useState([]); // 관심 캘린더 데이터
  const [selectedCalendarManagementRows, setSelectedCalendarManagementRows] =
    useState([]);

  // 캘린더 관련 상태
  const [myCalendars, setMyCalendars] = useState([]);
  const [calendarPopupOpen, setCalendarPopupOpen] = useState(false);
  const [editingCalendar, setEditingCalendar] = useState(null);
  const [calendarForm, setCalendarForm] = useState({
    description: '',
    color: '#6aa84f', // 기본 색상
    isPublic: '0', // 0: 공개, 1: 비공개
    calId: '',
  });
  const [colorPickerOpen, setColorPickerOpen] = useState({});
  const colorPalette = [
    { color: '#6aa84f', id: 1 }, // 녹색
    { color: '#1976d2', id: 2 }, // 파란색
    { color: '#d32f2f', id: 3 }, // 빨간색
    { color: '#f57c00', id: 4 }, // 주황색
    { color: '#7b1fa2', id: 5 }, // 보라색
    { color: '#00acc1', id: 6 }, // 청록색
    { color: '#f50057', id: 7 }, // 핑크색
    { color: '#ff9800', id: 8 }, // 황색
    { color: '#795548', id: 9 }, // 갈색
    { color: '#607d8b', id: 10 }, // 회색
    { color: '#4caf50', id: 11 }, // 라임색
    { color: '#ff5722', id: 12 }, // 주황빨강
    { color: '#2196f3', id: 13 }, // 하늘색
    { color: '#ffeb3b', id: 14 }, // 노란색
    { color: '#e91e63', id: 15 }, // 마젠타
    { color: '#009688', id: 16 }, // 틸색
    { color: '#673ab7', id: 17 }, // 인디고
    { color: '#3f51b5', id: 18 }, // 인디고블루
    { color: '#8bc34a', id: 19 }, // 라이트그린
    { color: '#ffc107', id: 20 }, // 앰버
  ];

  // 고정 공휴일 목록 (매년 같은 날짜)
  const fixedHolidays = [
    { month: 1, day: 1, name: '신정' },
    { month: 3, day: 1, name: '삼일절' },
    { month: 5, day: 5, name: '어린이날' },
    { month: 6, day: 6, name: '현충일' },
    { month: 8, day: 15, name: '광복절' },
    { month: 10, day: 3, name: '개천절' },
    { month: 12, day: 25, name: '크리스마스' },
  ];

  // 공휴일 확인 함수 (매년 자동으로 확인)
  const getHolidayForDate = (date) => {
    const dayjsDate = dayjs(date);
    const month = dayjsDate.month() + 1; // dayjs는 0부터 시작하므로 +1
    const day = dayjsDate.date();

    const holiday = fixedHolidays.find(
      (h) => h.month === month && h.day === day
    );

    return holiday ? holiday.name : null;
  };

  // 달력 뷰 관련 상태
  const [viewMode, setViewMode] = useState('month'); // day, week, month
  const [currentDate, setCurrentDate] = useState(dayjs());
  const [calendarEvents, setCalendarEvents] = useState([]);

  // 공유 캘린더 상태
  const [sharedCalendars, setSharedCalendars] = useState([]);

  // 팝업 상태
  const [scheduleDetailPopupOpen, setScheduleDetailPopupOpen] = useState(false);
  const [repeatSettingsPopupOpen, setRepeatSettingsPopupOpen] = useState(false);
  const [moreEventsPopupOpen, setMoreEventsPopupOpen] = useState(false);
  const [moreEventsData, setMoreEventsData] = useState({
    date: null,
    events: [],
  });
  const [isEditMode, setIsEditMode] = useState(false);
  const [pendingDeleteCalendars, setPendingDeleteCalendars] = useState([]);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [calendarManagementConfirmOpen, setCalendarManagementConfirmOpen] =
    useState(false);
  const [calendarManagementConfirmAction, setCalendarManagementConfirmAction] =
    useState(null); // 'accept' 또는 'delete'

  // 일정 폼 상태
  const [scheduleForm, setScheduleForm] = useState({
    title: '',
    description: '',
    location: '',
    isPrivate: false,
    calendarId: '',
    startDate: dayjs(),
    endDate: dayjs().add(1, 'hour'),
    isAllDay: false,
    isRepeat: false,
    alarmYn: false,
    alarms: [],
    calEId: '',
    calReId: '',
  });

  // 반복 설정 상태
  const [repeatSettings, setRepeatSettings] = useState({
    type: '', // 반복 유형
    interval: 0, // 반복 간격
    daysOfWeek: [], // 반복 요일
    monthlyType: '', // 반복 월간 타입
    dayOfMonth: 0, // 반복 월간 일자
    weekOfMonth: 0, // 반복 월간 주차
    dayOfWeek: 0, // 반복 월간 요일
    monthOfYear: 0, // 반복 년간 월
    endType: '', // 반복 종료 타입
    endDate: null, // 반복 종료 날짜
    endCount: null, // 반복 횟수
    calReId: '',
  });

  // 공유 캘린더 상태
  const [suppliers, setSuppliers] = useState([]); // 수급업체 목록
  const [supplierPopupOpen, setSupplierPopupOpen] = useState(false); // 수급업체 선택 팝업
  const [supplierGridData, setSupplierGridData] = useState([]); // 수급업체 그리드 데이터
  const [selectedSuppliers, setSelectedSuppliers] = useState([]); // 선택된 수급업체들
  const [searchKeyword, setSearchKeyword] = useState(''); // 공유자 검색 키워드

  // 공유캘린더 삭제 관련 상태 추가
  const [isSharedEditMode, setIsSharedEditMode] = useState(false);
  const [pendingDeleteSharedCalendars, setPendingDeleteSharedCalendars] =
    useState([]);

  //조회조건
  const searchRef = useRef({
    custCd: '', // 사업장 코드만 필요
  });

  // 회사/거래처 선택 상태 관리 및 필수 여부 검증을 위한 Hook
  const { handleCoChange, handleCustChange, validateSelection } =
    useCompanyCustDep({ searchRef, requireCompany: false, requireCust: false });

  // 검색 조건에서 사용할 시작일/종료일 상태 관리 Hook
  const { startDate, endDate, handleStartDateChange, handleEndDateChange } =
    useDateRange(searchRef);

  //#endregion
  const { refetch: Search1 } = useSearch1();
  const { run: Search2 } = useSearch2();
  const { run: Search3 } = useSearch3();
  const { run: Search4 } = useSearch4({
    onSuccess: (rows) => {
      setSupplierGridData(rows);
      setSupplierPopupOpen(true);
    },
  });
  const { run: Search5 } = useSearch5();
  const { run: Search6 } = useSearch6({
    onSuccess: (rows) => {
      const mappedData = rows.map((item) => ({
        id: item.calMId,
        name: item.name,
        calendarName: item.description,
        description: item.description,
        status: item.isWait === '0' ? '신청대기' : '공유 캘린더',
        setupDate: item.createDate || new Date(),
        calMId: item.calMId,
        calId: item.calId,
        userId: item.userId || userInfo.userid,
        isWait: item.isWait,
      }));
      setCalendarManagementData(mappedData);
    },
  });
  const { runAsync: Save1Async } = useSave1();
  const { runAsync: Save2Async } = useSave2();
  const { runAsync: Save3Async } = useSave3();
  const { runAsync: Save4Async } = useSave4();
  const { runAsync: Save5Async } = useSave5();
  const { runAsync: Delete1Async } = useDelete1();
  const { runAsync: Delete2Async } = useDelete2();
  const { runAsync: Delete3Async } = useDelete3();

  const updateCurrentRowData = (fieldName, value, skipValidation = false) => {
    if (!gridRef1.current || currentRowIndexRef.current === null) return;

    const api = gridRef1.current.api;
    const rowNode = api.getDisplayedRowAtIndex(currentRowIndexRef.current);
    if (!rowNode) return;

    const prevData = rowNode.data;
    const updatedRowData = {
      ...prevData,
      [fieldName]: value,
      editYn: 'Y',
    };

    rowNode.setData(updatedRowData);

    if (!Array.isArray(changedRowData1)) return;

    const alreadyChangedIndex = changedRowData1.findIndex(
      (item) => item.no === updatedRowData.no
    );
    const newChangedList = [...changedRowData1];

    if (alreadyChangedIndex > -1) {
      newChangedList[alreadyChangedIndex] = updatedRowData;
    } else {
      newChangedList.push(updatedRowData);
    }
    setChangedRowData1(newChangedList);
  };

  //#region 조회
  // 1. useRef 추가 (변수 선언 부분에)
  const isInitialLoadRef = useRef(true);
  // 조회 요청 추적을 위한 ref (SearchEventsLogic과 Init 모두에서 사용)
  const currentRequestIdRef = useRef(0);
  const isSearchingRef = useRef(false);
  // 날짜 범위 추적을 위한 ref
  const prevDateRangeRef = useRef('');
  const prevViewModeRef = useRef(viewMode);

  // SearchEventsLogic ref (최신 함수 참조 유지)
  const searchEventsLogicRef = useRef(null);

  //#region 색상변경 시 일정 재조회
  const RefreshEventsByView = (customCalendarsData = null) => {
    let start, end;
    if (viewMode === 'month') {
      // 월간 뷰: 달력에 표시되는 전체 범위 (첫 주 월요일부터 마지막 주 일요일까지)
      // GenerateMonthCalendar와 동일한 범위 계산
      const startOfMonth = currentDate.startOf('month');
      const endOfMonth = currentDate.endOf('month');
      const startOfCalendar = startOfMonth.startOf('week');
      const endOfCalendar = endOfMonth.endOf('week');

      start = startOfCalendar.startOf('day');
      end = endOfCalendar.endOf('day');
    } else if (viewMode === 'week') {
      start = currentDate.startOf('week').startOf('day');
      end = currentDate
        .endOf('week')
        .startOf('day')
        .add(1, 'day')
        .subtract(1, 'second');
    } else {
      start = currentDate.startOf('day');
      end = currentDate.endOf('day');
    }

    // 날짜 범위를 문자열로 변환
    const dateRangeStr = `${viewMode}-${start.format('YYYY-MM-DD')}-${end.format('YYYY-MM-DD')}`;

    // prevDateRangeRef를 현재 값으로 설정하여 useEffect의 중복 방지 로직과 일치
    prevDateRangeRef.current = dateRangeStr;

    // 새 요청 ID로 조회 실행 (이전 요청 자동 취소)
    const newRequestId = ++currentRequestIdRef.current;

    // ref를 통해 최신 함수 호출 (커스텀 캘린더 데이터가 있으면 전달)
    if (searchEventsLogicRef.current) {
      searchEventsLogicRef.current(
        start,
        end,
        newRequestId,
        customCalendarsData || null,
        {
          viewMode: viewMode,
          currentDate: currentDate,
        }
      );
    }
  };
  //#region 내 캘린더 조회
  // 캘린더 조회 함수
  const SearchCalendarLogic = async () => {
    if (!validateSelection()) return;
    try {
      const result = await Search1();
      const apiRes = result.data;
      const { isSuccess, message, severity, data } = apiRes;
      if (!isSuccess) {
        setMyCalendars([]);
        dispatch(showSnackbar({ message: message, type: severity || 'error' }));
        return;
      }
      const rows = Array.isArray(data) ? data : [];
      if (!rows.length) {
        setMyCalendars([]);
        dispatch(showSnackbar({ message, type: severity || 'info' }));
        return;
      }

      const calendarData = data.map((item) => ({
        calId: item.calId,
        description: item.description,
        color: item.color,
        isPublic: item.isPublic,
        ownerId: item.ownerId,
        mainCalendar: item.mainCalendar,
        checked: item.isPublic === '0', //기본 공개캘린더에 체크
      }));
      setMyCalendars(calendarData);

      await SearchSharedCalendarLogic();
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  //#region 공유캘린더 조회
  const SearchSharedCalendarLogic = async () => {
    if (!validateSelection()) return;
    try {
      Search3(
        { userInfo },
        {
          onSuccess: (rows) => {
            const mappedData = rows.map((item) => ({
              id: item.calMId,
              calMId: item.calMId,
              name: item.name,
              calendarNm: item.calendarNm,
              color: item.color,
              checked: item.isPublic === '0',
              calId: item.ownerCalId,
              userId: item.userId,
              isWait: item.isWait,
            }));
            setSharedCalendars(mappedData);
          },
        }
      );
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  // 캘린더 환경설정 데이터 조회
  const SearchCalendarManagementData = async (viewType = 'myFavorites') => {
    try {
      if (viewType === 'myFavorites') {
        // 내가 등록한 관심캘린더 조회
        Search3(
          { userInfo },
          {
            onSuccess: (rows) => {
              const mappedData = rows.map((item) => ({
                id: item.calMId,
                name: item.name,
                calendarName: item.CalendarNm,
                status: item.isWait === '0' ? '신청대기' : '공유 캘린더',
                setupDate: item.createDate || item.updateDate || new Date(),
                calMId: item.calMId,
                calId: item.ownerCalId,
                userId: item.userId,
                isWait: item.isWait,
                COLOR: item.color,
                isPublic: item.isPublic,
                description: item.description,
              }));
              setCalendarManagementData(mappedData);
            },
          }
        );
      } else {
        // 내 일정을 보고 있는 동료 조회
        Search6({ userInfo });
      }
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
      setCalendarManagementData([]);
    }
  };

  // 캘린더 환경설정 데이터 삭제
  const DeleteCalendarManagementData = async (rows) => {
    if (!rows || rows.length === 0) {
      dispatch(
        showSnackbar({
          message: '삭제할 항목을 선택하세요.',
          type: 'warning',
        })
      );
      return;
    }

    try {
      const results = await Promise.all(rows.map((row) => Delete2Async([row])));
      let successCount = 0;
      let errorCount = 0;

      results.forEach((result) => {
        if (result?.severity === 'error') {
          errorCount++;
        } else {
          successCount++;
        }
      });

      if (successCount > 0 && errorCount === 0) {
        dispatch(
          showSnackbar({
            message: `${successCount}개의 항목이 삭제되었습니다.`,
            type: 'success',
          })
        );
        await SearchCalendarManagementData(favoriteCalendarView);
        setSelectedCalendarManagementRows([]);
      } else if (successCount > 0 && errorCount > 0) {
        dispatch(
          showSnackbar({
            message: `${successCount}개 성공, ${errorCount}개 실패`,
            type: 'warning',
          })
        );
        await SearchCalendarManagementData(favoriteCalendarView);
      } else {
        dispatch(
          showSnackbar({
            message: '삭제에 실패했습니다.',
            type: 'error',
          })
        );
      }
    } catch (e) {
      console.error(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  // 캘린더 환경설정 데이터 수락 (내 일정을 보고 있는 동료 신청 수락)
  const AcceptCalendarManagementData = async (rows) => {
    if (!rows || rows.length === 0) {
      dispatch(
        showSnackbar({
          message: '수락할 항목을 선택하세요.',
          type: 'warning',
        })
      );
      return;
    }

    try {
      const results = await Promise.all(
        rows.map((row) => {
          const calMId = row.calMId || row.id;
          return Save5Async([{ calMId }], { userInfo });
        })
      );
      let successCount = 0;
      let errorCount = 0;

      results.forEach((result) => {
        if (result?.severity === 'error') {
          errorCount++;
        } else {
          successCount++;
        }
      });

      if (successCount > 0 && errorCount === 0) {
        dispatch(
          showSnackbar({
            message: `${successCount}개의 신청이 수락되었습니다.`,
            type: 'success',
          })
        );
        await SearchCalendarManagementData(favoriteCalendarView);
        setSelectedCalendarManagementRows([]);
      } else if (successCount > 0 && errorCount > 0) {
        dispatch(
          showSnackbar({
            message: `${successCount}개 수락 성공, ${errorCount}개 실패`,
            type: 'warning',
          })
        );
        await SearchCalendarManagementData(favoriteCalendarView);
      } else {
        dispatch(
          showSnackbar({
            message: '수락에 실패했습니다.',
            type: 'error',
          })
        );
      }
    } catch (e) {
      console.error(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  //#endregion
  //#region 저장

  //#region 내캘린더 공개/비공개 변경 체크박스 활성화, 비활성화
  const UpdateCalendarPublicLogic = async (calendarId, isChecked) => {
    if (!validateSelection()) return;

    try {
      // calendarId에서 calId 찾기 (calendarId가 객체일 수도 있고 숫자일 수도 있음)
      const calId =
        typeof calendarId === 'object'
          ? calendarId.calId || calendarId.id || calendarId
          : calendarId;

      // 내 캘린더에서 OWNER_ID 찾기
      const currentCalendar = myCalendars.find(
        (cal) => cal.calId === calId || cal.id === calId
      );
      const ownerId = currentCalendar?.ownerId || userInfo.userid;

      const updateData = {
        calId: calId,
        gubun: '0',
        userId: ownerId,
        isPublic: isChecked ? '0' : '1',
        calMId: '0',
      };

      const result = await Save2Async([updateData], { userInfo });
      if (result && result.severity !== 'error') {
        // 체크 상태를 먼저 업데이트하여 UI에 즉시 반영
        setMyCalendars((prev) => {
          const updated = prev.map((cal) =>
            cal.calId === calId || cal.id === calId
              ? {
                  ...cal,
                  checked: isChecked,
                  isPublic: isChecked ? '0' : '1',
                }
              : cal
          );

          // 최신 상태로 일정 재조회 (동기적으로 처리)
          RefreshEventsByView({
            myCalendars: updated,
            sharedCalendars: sharedCalendars,
          });

          return updated;
        });
      } else {
        throw new Error(result?.message || '캘린더 설정 변경에 실패했습니다.');
      }
    } catch (e) {
      dispatch(
        showSnackbar({
          message: e.message || '캘린더 설정 변경에 실패했습니다.',
          type: 'error',
        })
      );
      throw e;
    }
  };

  //#region 공유캘린더 공개/비공개 변경
  const UpdateSharedCalendarPublicLogic = async (calendarId, isChecked) => {
    if (!validateSelection()) return;

    try {
      // 공유 캘린더 정보 찾기 - calMId만 정확히 비교 (타입 변환 고려)
      const existingSharedCalendar = sharedCalendars.find(
        (cal) =>
          String(cal.calMId) === String(calendarId) ||
          Number(cal.calMId) === Number(calendarId) ||
          cal.calMId === calendarId
      );

      if (!existingSharedCalendar) {
        dispatch(
          showSnackbar({
            message: '공유 캘린더를 찾을 수 없습니다.',
            type: 'error',
          })
        );
        return;
      }

      // existingSharedCalendar에서 userId, calId, calMId 가져오기
      const userId = existingSharedCalendar.userId;
      const calMId = existingSharedCalendar.calMId;

      const updateData = {
        calId: calMId,
        gubun: '1',
        userId: userId,
        isPublic: isChecked ? '0' : '1',
        calMId: calMId,
      };

      const result = await Save2Async([updateData], { userInfo });
      if (result && result.severity !== 'error') {
        // 체크 상태를 먼저 업데이트하여 UI에 즉시 반영
        setSharedCalendars((prev) => {
          const updatedShared = prev.map((cal) =>
            String(cal.calMId) === String(calendarId) ||
            Number(cal.calMId) === Number(calendarId) ||
            cal.calMId === calendarId
              ? {
                  ...cal,
                  checked: isChecked,
                  isPublic: isChecked ? '0' : '1',
                }
              : cal
          );

          // 최신 상태로 일정 재조회 (동기적으로 처리)
          RefreshEventsByView({
            myCalendars: myCalendars,
            sharedCalendars: updatedShared.map((cal) => {
              const calIdToUse = cal.calId || cal.calMId;
              return {
                ...cal,
                calId: calIdToUse,
                ownerId: cal.ownerId || cal.userId,
              };
            }),
          });

          return updatedShared;
        });

        // 공유 캘린더 목록 다시 조회 (서버와 동기화) - 백그라운드로 처리
        SearchSharedCalendarLogic().then(() => {
          // 조회 완료 후 체크 상태 유지
          setSharedCalendars((prev) => {
            return prev.map((cal) =>
              String(cal.calMId) === String(calendarId) ||
              Number(cal.calMId) === Number(calendarId) ||
              cal.calMId === calendarId
                ? {
                    ...cal,
                    checked: isChecked,
                    isPublic: isChecked ? '0' : '1',
                  }
                : cal
            );
          });
        });
      } else {
        throw new Error(
          result?.message || '공유캘린더 설정 변경에 실패했습니다.'
        );
      }
    } catch (e) {
      dispatch(
        showSnackbar({
          message: e.message || '공유캘린더 설정 변경에 실패했습니다.',
          type: 'error',
        })
      );
      throw e;
    }
  };

  //#region 캘린더 색상 변경
  // 캘린더 이름 변경 함수
  const UpdateCalendarDescriptionLogic = async (calendarId, newDescription) => {
    if (!validateSelection()) return;

    if (!newDescription || !newDescription.trim()) {
      dispatch(
        showSnackbar({
          message: '캘린더 이름을 입력하세요.',
          type: 'warning',
        })
      );
      return;
    }

    // calendarId를 문자열로 변환 (타입 일치를 위해)
    const calIdStr = String(calendarId);

    // 이전 이름 저장 (롤백용)
    const previousCalendar = myCalendars.find(
      (cal) => String(cal.calId) === calIdStr || String(cal.id) === calIdStr
    );
    const previousDescription = previousCalendar?.description;

    // 즉시 로컬 상태 업데이트 (UI 반영)
    setMyCalendars((prev) =>
      prev.map((cal) =>
        String(cal.calId) === calIdStr || String(cal.id) === calIdStr
          ? { ...cal, description: newDescription.trim() }
          : cal
      )
    );

    try {
      const calendar = myCalendars.find(
        (cal) => String(cal.calId) === calIdStr || String(cal.id) === calIdStr
      );
      const updateData = {
        calId: calendarId,
        description: newDescription.trim(),
        color: calendar?.color || '#6aa84f',
        isPublic: calendar?.isPublic || '0',
      };

      const result = await Save3Async([updateData], { userInfo });
      if (result && result.severity !== 'error') {
        await SearchCalendarLogic();
        RefreshEventsByView();
        dispatch(
          showSnackbar({
            message: '캘린더 이름이 변경되었습니다.',
            type: 'success',
          })
        );
      } else {
        // 실패 시 롤백
        setMyCalendars((prev) =>
          prev.map((cal) =>
            String(cal.calId) === calIdStr || String(cal.id) === calIdStr
              ? { ...cal, description: previousDescription }
              : cal
          )
        );
        dispatch(
          showSnackbar({
            message: result?.message || '캘린더 이름 변경에 실패했습니다.',
            type: 'error',
          })
        );
      }
    } catch (e) {
      // 실패 시 롤백
      const previousCalendar = myCalendars.find(
        (cal) => String(cal.calId) === calIdStr || String(cal.id) === calIdStr
      );
      setMyCalendars((prev) =>
        prev.map((cal) =>
          String(cal.calId) === calIdStr || String(cal.id) === calIdStr
            ? { ...cal, description: previousCalendar?.description }
            : cal
        )
      );
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  const UpdateCalendarColorLogic = async (calendarId, newColor) => {
    if (!validateSelection()) return;

    // calendarId를 문자열로 변환 (타입 일치를 위해)
    const calIdStr = String(calendarId);

    // 이전 색상 저장 (롤백용)
    const previousCalendar = myCalendars.find(
      (cal) => String(cal.calId) === calIdStr || String(cal.id) === calIdStr
    );
    const previousColor = previousCalendar?.color;

    // 달력 이벤트 색상 즉시 업데이트 (새 배열 참조로 강제 리렌더링)
    const updatedEvents = calendarEvents.map((ev) => {
      const evCalId = String(ev.calId || ev.calId || '');
      if (evCalId === calIdStr) {
        return {
          ...ev,
          color: newColor,
          displayColor: newColor,
        };
      }
      return ev;
    });
    setCalendarEvents(updatedEvents);

    // 즉시 로컬 상태 업데이트 (UI 반영)
    setMyCalendars((prev) =>
      prev.map((cal) =>
        String(cal.calId) === calIdStr || String(cal.id) === calIdStr
          ? { ...cal, color: newColor }
          : cal
      )
    );

    try {
      const calendar = myCalendars.find(
        (cal) => String(cal.calId) === calIdStr || String(cal.id) === calIdStr
      );

      const updateData = {
        calId: String(calendarId),
        description: calendar.description,
        color: newColor,
        isPublic: '0',
      };

      const result = await Save3Async([updateData], { userInfo });
      if (result && result.severity === 'error') {
        // 실패 시 롤백
        setMyCalendars((prev) =>
          prev.map((cal) =>
            String(cal.calId) === calIdStr || String(cal.id) === calIdStr
              ? { ...cal, color: previousColor }
              : cal
          )
        );
        const rolledBackEvents = calendarEvents.map((ev) => {
          const evCalId = String(ev.calId || ev.calId || '');
          if (evCalId === calIdStr) {
            return {
              ...ev,
              color: previousColor,
              displayColor: previousColor,
            };
          }
          return ev;
        });
        setCalendarEvents(rolledBackEvents);
        dispatch(
          showSnackbar({
            message: result?.message || '색상 변경에 실패했습니다.',
            type: 'error',
          })
        );
      }
    } catch (e) {
      // 실패 시 롤백
      setMyCalendars((prev) =>
        prev.map((cal) =>
          String(cal.calId) === calIdStr || String(cal.id) === calIdStr
            ? { ...cal, color: previousColor }
            : cal
        )
      );
      const rolledBackEvents = calendarEvents.map((ev) => {
        const evCalId = String(ev.calId || ev.calId || '');
        if (evCalId === calIdStr) {
          return {
            ...ev,
            color: previousColor,
            displayColor: previousColor,
          };
        }
        return ev;
      });
      setCalendarEvents(rolledBackEvents);
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };
  //#region 공유캘린더 색상 변경
  const UpdateSharedCalendarColorLogic = async (sharedCalendarId, newColor) => {
    if (!validateSelection()) return;

    // sharedCalendarId가 calMId인지 calId인지 모두 대응
    const existingSharedCalendar =
      sharedCalendars.find((cal) => cal.calMId === sharedCalendarId) ||
      sharedCalendars.find((cal) => cal.calId === sharedCalendarId);

    if (!existingSharedCalendar) {
      dispatch(
        showSnackbar({
          message: '공유캘린더를 찾을 수 없습니다.',
          type: 'error',
        })
      );
      return;
    }

    // 이전 색상 저장 (롤백용)
    const previousColor =
      existingSharedCalendar.color || existingSharedCalendar.COLOR;
    const targetCalId = String(
      existingSharedCalendar.calId || existingSharedCalendar.ownerCalId || ''
    );

    // 달력 이벤트 색상 즉시 업데이트 (새 배열 참조로 강제 리렌더링)
    const updatedEvents = calendarEvents.map((ev) => {
      const evCalId = String(ev.calId || '');
      // 공유 캘린더의 calId와 일치하는 일정의 색상 업데이트
      if (evCalId === targetCalId) {
        return {
          ...ev,
          color: newColor,
          displayColor: newColor,
        };
      }
      return ev;
    });
    setCalendarEvents(updatedEvents);

    // 즉시 로컬 상태 업데이트 (UI 반영)
    setSharedCalendars((prev) =>
      prev.map((cal) =>
        String(cal.calMId) === String(sharedCalendarId) ||
        Number(cal.calMId) === Number(sharedCalendarId) ||
        cal.calMId === sharedCalendarId ||
        String(cal.calId) === String(sharedCalendarId) ||
        Number(cal.calId) === Number(sharedCalendarId) ||
        cal.calId === sharedCalendarId
          ? { ...cal, color: newColor, COLOR: newColor }
          : cal
      )
    );

    try {
      const updateData = {
        calMId: String(sharedCalendarId ?? 0),
        calId: String(existingSharedCalendar.calId ?? 0),
        userId: existingSharedCalendar.userId,
        color: newColor,
      };

      const result = await Save4Async([updateData], { userInfo });
      if (result && result.severity === 'error') {
        // 실패 시 롤백
        setSharedCalendars((prev) =>
          prev.map((cal) =>
            String(cal.calMId) === String(sharedCalendarId) ||
            Number(cal.calMId) === Number(sharedCalendarId) ||
            cal.calMId === sharedCalendarId ||
            String(cal.calId) === String(sharedCalendarId) ||
            Number(cal.calId) === Number(sharedCalendarId) ||
            cal.calId === sharedCalendarId
              ? { ...cal, color: previousColor, COLOR: previousColor }
              : cal
          )
        );
        const rolledBackEvents = calendarEvents.map((ev) => {
          const evCalId = String(ev.calId || '');
          if (evCalId === targetCalId) {
            return {
              ...ev,
              color: previousColor,
              displayColor: previousColor,
            };
          }
          return ev;
        });
        setCalendarEvents(rolledBackEvents);
        dispatch(
          showSnackbar({
            message: result?.message || '공유캘린더 색상 변경에 실패했습니다.',
            type: 'error',
          })
        );
      } else {
        // 성공 시 재조회 후에도 색상 유지
        await SearchSharedCalendarLogic().then(() => {
          // 조회 완료 후 색상 유지
          setSharedCalendars((prev) =>
            prev.map((cal) =>
              String(cal.calMId) === String(sharedCalendarId) ||
              Number(cal.calMId) === Number(sharedCalendarId) ||
              cal.calMId === sharedCalendarId ||
              String(cal.calId) === String(sharedCalendarId) ||
              Number(cal.calId) === Number(sharedCalendarId) ||
              cal.calId === sharedCalendarId
                ? { ...cal, color: newColor, COLOR: newColor }
                : cal
            )
          );
        });
        RefreshEventsByView();
        dispatch(
          showSnackbar({
            message: '공유캘린더 색상이 변경되었습니다.',
            type: 'success',
          })
        );
      }
    } catch (e) {
      // 실패 시 롤백
      setSharedCalendars((prev) =>
        prev.map((cal) =>
          String(cal.calMId) === String(sharedCalendarId) ||
          Number(cal.calMId) === Number(sharedCalendarId) ||
          cal.calMId === sharedCalendarId ||
          String(cal.calId) === String(sharedCalendarId) ||
          Number(cal.calId) === Number(sharedCalendarId) ||
          cal.calId === sharedCalendarId
            ? { ...cal, color: previousColor, COLOR: previousColor }
            : cal
        )
      );
      const rolledBackEvents = calendarEvents.map((ev) => {
        const evCalId = String(ev.calId || '');
        if (evCalId === targetCalId) {
          return {
            ...ev,
            color: previousColor,
            displayColor: previousColor,
          };
        }
        return ev;
      });
      setCalendarEvents(rolledBackEvents);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };
  //#endregion

  //#region 캘린더 저장/수정
  // 캘린더 저장/수정 통합 함수 (프로시저에서 calId로 추가/수정 구분)
  const SaveCalendarLogic = async (
    calendarForm,
    editingCalendar,
    onSuccess
  ) => {
    if (!validateSelection()) return;

    try {
      const saveData = {
        calId: calendarForm.calId || '0',
        description: calendarForm.description,
        color: '#6aa84f', // 기본 색상으로 고정
        isPublic: '1', // 기본 비공개로 저장 (0:공개,1:비공개)
      };

      const result = await Save3Async([saveData], { userInfo });
      if (result && result.severity !== 'error') {
        dispatch(
          showSnackbar({
            message: '내 캘린더가 저장되었습니다.',
            type: 'success',
          })
        );
        SearchCalendarLogic();
        if (onSuccess) {
          onSuccess();
        }
      } else {
        dispatch(
          showSnackbar({
            message: result?.message || '에러가 발생했습니다.',
            type: 'error',
          })
        );
      }
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  //#region 공유캘린더를 공유 캘린더에 저장하는 함수
  const SaveSupplierToCalendar = async (supplierData) => {
    if (!validateSelection()) return false;

    try {
      const saveData = {
        calMId: supplierData.calMId || 0,
        calId: supplierData.calId || 0,
        userId: supplierData.userId,
        color: supplierData.color,
      };

      const result = await Save4Async([saveData], { userInfo });
      if (result && result.severity !== 'error') {
        return true;
      } else {
        dispatch(
          showSnackbar({
            message: result?.message || '저장에 실패했습니다.',
            type: 'error',
          })
        );
        return false;
      }
    } catch (e) {
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
      return false;
    }
  };

  //#region 캘린더 삭제
  // 캘린더 삭제 함수
  const DeleteCalendarLogic = async (calendarIds) => {
    if (!validateSelection()) return;

    // calendarIds 안전하게 배열로 변환
    let idsArray = [];
    try {
      if (Array.isArray(calendarIds)) {
        idsArray = calendarIds.filter(
          (id) =>
            id !== null && id !== undefined && id !== '' && !isNaN(Number(id))
        );
      } else if (calendarIds && typeof calendarIds === 'object') {
        idsArray = Object.values(calendarIds).filter(
          (id) =>
            id !== null && id !== undefined && id !== '' && !isNaN(Number(id))
        );
      } else if (
        calendarIds !== null &&
        calendarIds !== undefined &&
        calendarIds !== ''
      ) {
        const numId = Number(calendarIds);
        if (!isNaN(numId)) {
          idsArray = [numId];
        }
      }
    } catch (e) {
      dispatch(
        showSnackbar({
          message: '삭제할 캘린더 ID가 유효하지 않습니다.',
          type: 'error',
        })
      );
      return;
    }

    if (idsArray.length === 0) {
      dispatch(
        showSnackbar({
          message: '삭제할 캘린더가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    try {
      const results = await Promise.all(
        idsArray.map((id) => Delete1Async([{ calId: String(id) }]))
      );
      let successCount = 0;
      let errorCount = 0;

      results.forEach((result) => {
        if (result?.severity === 'error') {
          errorCount++;
        } else {
          successCount++;
        }
      });

      if (successCount > 0 && errorCount === 0) {
        dispatch(
          showSnackbar({
            message: `${successCount}개의 캘린더가 삭제되었습니다.`,
            type: 'success',
          })
        );
        SearchCalendarLogic();
      } else if (successCount > 0 && errorCount > 0) {
        dispatch(
          showSnackbar({
            message: `${successCount}개 삭제 성공, ${errorCount}개 삭제 실패`,
            type: 'warning',
          })
        );
        SearchCalendarLogic();
      } else {
        dispatch(
          showSnackbar({
            message: '캘린더 삭제에 실패했습니다.',
            type: 'error',
          })
        );
      }
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  //#region 일정 조회 (SP_CALENDARS_R2)
  const SearchEventsLogic = useCallback(
    async (
      rangeStart,
      rangeEnd,
      requestId = null,
      calendarsData = null,
      options = {}
    ) => {
      if (!validateSelection()) return;

      // 요청 ID 생성 및 확인
      let reqId;
      if (requestId !== null) {
        reqId = requestId;
        if (reqId !== currentRequestIdRef.current) {
          return;
        }
      } else {
        reqId = ++currentRequestIdRef.current;
      }

      if (reqId !== currentRequestIdRef.current) {
        return; // 이미 취소된 요청
      }

      isSearchingRef.current = true;

      try {
        const startDateTime = dayjs(rangeStart);
        const endDateTime = dayjs(rangeEnd);

        const calendarsToUseForQuery = calendarsData || {
          myCalendars: myCalendars,
          sharedCalendars: sharedCalendars,
        };

        // 체크된 공유 캘린더 목록
        const checkedSharedCalendars =
          calendarsToUseForQuery.sharedCalendars.filter(
            (cal) => cal.checked === true
          );

        // 체크된 공유 캘린더의 calId 목록 생성 (체크 해제된 캘린더 제외)
        // 공유 캘린더는 OWNER_calId (소유자의 캘린더 ID)를 사용
        const checkedSharedCalIds = new Set();
        const checkedSharedCalMIds = new Set(); // calMId도 추적하여 정확한 필터링
        checkedSharedCalendars.forEach((cal) => {
          if (cal.checked === true) {
            // 공유 캘린더의 calId는 ownerId (소유자의 캘린더 ID)
            const calId = String(
              cal.calId || cal.ownerCalId || cal.calMId || ''
            );
            if (
              calId &&
              calId !== 'undefined' &&
              calId !== 'null' &&
              calId !== ''
            ) {
              checkedSharedCalIds.add(calId);
              // calMId도 추가하여 정확한 매칭
              if (cal.calMId) {
                checkedSharedCalMIds.add(String(cal.calMId));
              }
            }
          }
        });

        // 체크된 내 캘린더의 calId 목록 생성
        const checkedMyCalIds = new Set();
        calendarsToUseForQuery.myCalendars.forEach((cal) => {
          if (cal.checked === true && cal.calId) {
            checkedMyCalIds.add(String(cal.calId));
          }
        });

        // 모든 캘린더가 체크 해제되었는지 확인
        const hasCheckedCalendars =
          checkedMyCalIds.size > 0 || checkedSharedCalIds.size > 0;

        // 모든 캘린더가 체크 해제되었으면 빈 배열 반환
        if (!hasCheckedCalendars) {
          if (reqId === currentRequestIdRef.current) {
            setCalendarEvents([]);
            isSearchingRef.current = false;
          }
          return;
        }

        // SP_CALENDARS_R2 호출: 로그인 사용자 ID로 호출
        // 프로시저에서 내 캘린더(OWNER_ID = _userId)와 공유 캘린더(CREATE_ID = _userId) 모두 조회됨
        const axiosResult = await Commons.Axios(
          'post',
          Global.base.useUrl + Global.urls.Calendar.getCalendarR2,
          {
            UserId: userInfo.userid || '',
            StartDt:
              Commons.EncryptAES(startDateTime.format('YYYY-MM-DD HH:mm:ss')) ||
              '',
            EndDt:
              Commons.EncryptAES(endDateTime.format('YYYY-MM-DD HH:mm:ss')) ||
              '',
          }
        );
        const apiRes = axiosResult.data;
        const axiosResultData = apiRes.data;
        const { isSuccess, message, severity } = apiRes;
        if (!isSuccess) {
          dispatch(
            showSnackbar({ message: message, type: severity || 'error' })
          );
          return;
        }
        const rows = Array.isArray(axiosResultData) ? axiosResultData : [];
        if (!rows.length) {
          // 데이터가 없으면 빈 배열로 설정
          if (reqId === currentRequestIdRef.current) {
            setCalendarEvents([]);
            isSearchingRef.current = false;
          }
          return;
        }
        // 결과 필터링: 체크된 캘린더만 포함 (체크 해제된 캘린더의 일정은 명확하게 제외)
        let allData = [];
        if (axiosResultData && axiosResultData.length > 0) {
          // 중복 제거를 위한 Set (calEId 기준)
          const seenEventIds = new Set();

          allData = axiosResultData.filter((event) => {
            // 쿼리 결과 필드명 매핑 (대문자 시작 필드명 지원)
            const eventCalId = String(event.CalId || event.calId || '');
            if (
              !eventCalId ||
              eventCalId === 'undefined' ||
              eventCalId === 'null' ||
              eventCalId === ''
            ) {
              return false;
            }
            // 내 캘린더 또는 체크된 공유 캘린더인 경우만 포함
            const isMyCalendar = checkedMyCalIds.has(eventCalId);
            const isSharedCalendar = checkedSharedCalIds.has(eventCalId);
            // 체크된 캘린더의 일정만 포함 (체크 해제된 캘린더의 일정은 제외)
            if (!isMyCalendar && !isSharedCalendar) {
              return false;
            }

            // 중복 제거: 반복 일정 인스턴스는 각각 다른 startDt/endDt를 가지므로 이를 포함한 고유 ID 생성
            const calEId = event.CalEId || event.calEId || '';
            const calReId = event.CalReId || event.calReId || '';
            const startDt = event.StartDt || event.startDt || '';
            const endDt = event.EndDt || event.endDt || '';
            // 반복 일정인 경우 (calReId가 있으면) startDt와 endDt를 포함한 고유 ID 생성
            // 일반 일정인 경우 calEId만 사용
            const eventId = calReId
              ? `${calEId || eventCalId}-${startDt}-${endDt}`
              : calEId || `${eventCalId}-${startDt}-${endDt}`;
            if (seenEventIds.has(eventId)) {
              return false; // 이미 포함된 일정은 제외
            }
            seenEventIds.add(eventId);

            return true;
          });
        }

        // 필터링 후 데이터가 없으면 빈 배열 반환
        if (!allData || allData.length === 0) {
          if (reqId === currentRequestIdRef.current) {
            setCalendarEvents([]);
            isSearchingRef.current = false;
          }
          return;
        }
        // 결과를 result 형식으로 변환
        const result = {
          data: allData,
        };
        // 응답을 받은 직후 최신 요청인지 확인
        if (reqId !== currentRequestIdRef.current) {
          isSearchingRef.current = false;
          return; // 이전 요청이면 무시
        }

        const data = result.data || [];

        if (data[0]?.type === 'Error') {
          // 최신 요청인지 다시 확인
          if (reqId === currentRequestIdRef.current) {
            dispatch(showSnackbar({ message: data[0].message, type: 'error' }));
            isSearchingRef.current = false;
          }
          return;
        }

        // 캘린더 데이터 사용 (파라미터로 전달된 경우 사용, 없으면 상태에서 가져옴)
        const calendarsToUse = calendarsData || {
          myCalendars: myCalendars,
          sharedCalendars: sharedCalendars,
        };

        // myCalendars에서 체크된 캘린더만 calId별 색상 매핑 생성
        const calendarColorMap = new Map();
        calendarsToUse.myCalendars.forEach((cal) => {
          // 체크된 캘린더만 색상 매핑에 포함
          if (cal.calId && cal.color && cal.checked === true) {
            calendarColorMap.set(String(cal.calId), cal.color);
          }
        });

        // sharedCalendars에서 체크된 캘린더만 calId별 색상 매핑 생성
        calendarsToUse.sharedCalendars.forEach((cal) => {
          const calColor = cal.color || cal.color;
          // 체크된 캘린더만 색상 매핑에 포함
          if (cal.calId && calColor && cal.checked === true) {
            // calId와 calMId 모두 매핑 (일정 데이터의 calId가 어느 쪽과 일치할 수 있음)
            calendarColorMap.set(String(cal.calId), calColor);
            if (cal.calMId) {
              calendarColorMap.set(String(cal.calMId), calColor);
            }
          }
        });

        const mapped = data.map((e) => {
          // 쿼리 결과 필드명 매핑 (대문자 시작 필드명 지원)
          const calEId = e.CalEId || e.calEId || '';
          const calId = String(e.CalId || e.calId || '');
          const title = e.Title || e.title || '';
          const description = e.Description || e.description || '';
          const location = e.Location || e.location || '';
          const displayColor = e.DisplayColor || e.displayColor || '';
          const calReId = e.CalReId || e.calReId || '';
          const visibility = e.Visibility || e.visibility || '';
          const recurrenceType = e.RecurrenceType || e.recurrenceType || '';
          const recurrenceInterval =
            e.RecurrenceInterval || e.recurrenceInterval || 0;
          const byWeekDay = e.ByWeekDay || e.byWeekDay || '';
          const byMonthDay = e.ByMonthDay || e.byMonthDay || '';
          const rruleEndType =
            e.RruleEndType || e.rruleEndType || e.recurrenceEndType || '';
          const recurrenceCount = e.RecurrenceCount || e.recurrenceCount || 0;
          const recurrenceUntil = e.RecurrenceUntil || e.recurrenceUntil || '';
          const alarmId = e.AlarmId || e.alarmId || '';
          const alarmValue = e.AlarmValue || e.alarmValue || '';
          const alarmUnitText = e.AlarmUnitText || e.alarmUnitText || '';

          const colorFromCalendar = calendarColorMap.get(calId) || displayColor;

          // 날짜 유효성 검증 및 수정
          // 백엔드가 반환하는 필드명이 StartDt/EndDt (대문자)일 수 있으므로 모두 확인
          const startDtValue =
            e.StartDt || e.startDt || e.START_DT || e.start_DT;
          const endDtValue = e.EndDt || e.endDt || e.END_DT || e.end_DT;
          let startDate = dayjs(startDtValue);
          let endDate = dayjs(endDtValue);

          // 시작 날짜가 유효하지 않거나 잘못된 형식인 경우 수정
          if (!startDate.isValid()) {
            startDate = dayjs(); // 현재 날짜로 대체
          } else {
            // 날짜 문자열에 '-00'이 포함되어 있는지 확인
            const startStr = startDate.format('YYYY-MM-DD');
            if (startStr.includes('-00')) {
              startDate = startDate.startOf('month'); // 해당 월의 1일로 수정
            }
          }

          // 종료 날짜가 유효하지 않거나 잘못된 형식인 경우 수정
          if (!endDate.isValid()) {
            endDate = startDate.add(1, 'hour'); // 시작 날짜 + 1시간으로 대체
          } else {
            // 날짜 문자열에 '-00'이 포함되어 있는지 확인
            const endStr = endDate.format('YYYY-MM-DD');
            if (endStr.includes('-00')) {
              endDate = endDate.startOf('month'); // 해당 월의 1일로 수정
            }
          }

          // ALL_DAY 값 확인 및 종일 일정 판단
          // 1. ALL_DAY 플래그가 있으면 종일
          // 2. 시작일과 종료일이 같은 날짜이고, 모두 00:00:00이면 종일
          // 3. 시작일과 종료일이 같은 날짜이고, 시작일이 00:00:00, 종료일이 23:59:59이면 종일
          const allDayValue = e.AllDay || e.allDay;
          const hasAllDayFlag =
            allDayValue === 'Y' || allDayValue === 'y' || allDayValue === true;

          const isSameDay = startDate.isSame(endDate, 'day');
          const startIsMidnight =
            startDate.hour() === 0 &&
            startDate.minute() === 0 &&
            startDate.second() === 0;
          const endIsMidnight =
            endDate.hour() === 0 &&
            endDate.minute() === 0 &&
            endDate.second() === 0;
          const endIsEndOfDay =
            endDate.hour() === 23 &&
            endDate.minute() === 59 &&
            endDate.second() === 59;

          const isAllDay =
            hasAllDayFlag ||
            (isSameDay && startIsMidnight && (endIsMidnight || endIsEndOfDay));

          // 반복 일정 인스턴스의 경우 각 인스턴스마다 고유한 ID 생성
          // calREId가 있으면 반복 일정이므로 날짜를 포함한 고유 ID 생성
          const eventId = calReId
            ? `${calEId || calId}-${startDtValue}-${endDtValue}`
            : calEId || `${calId}-${startDtValue}`;

          return {
            id: eventId,
            title: title,
            description: description,
            location: location,
            start: startDate,
            end: endDate,
            // 원본 문자열도 유지 (필터링에서 사용)
            startDt: startDtValue,
            endDt: endDtValue,
            allDay: isAllDay, // 계산된 종일 여부
            allDayOriginal: allDayValue, // 원본 allDay 값 유지 (필터링에서 사용)
            color: colorFromCalendar,
            displayColor: colorFromCalendar, // DISPLAY_COLOR도 함께 저장
            calId: calId,
            calREId: calReId,
            calEId: calEId,
            visibility: visibility,
            recurrence_count: recurrenceCount,
            recurrenceInterval: recurrenceInterval,
            recurrenceType: recurrenceType,
            recurrenceUntil: recurrenceUntil,
            recurrenceEndType: rruleEndType,
            byWeekDay: byWeekDay,
            byMonthDay: byMonthDay,
            endType: rruleEndType,
            endDate: recurrenceUntil,
            alarmId: alarmId,
            alarmValue: alarmValue,
            alarmUnitText: alarmUnitText,
          };
        });

        // 백엔드가 이미 반복 일정 인스턴스를 생성해서 반환하므로, 프론트엔드에서는 확장하지 않고 그대로 사용
        // 백엔드 쿼리에서 DAILY_INSTANCES, WEEKLY_INSTANCES(OCC_INSTANCES), MONTHLY_INSTANCES, YEARLY_INSTANCES로
        // 이미 모든 인스턴스를 생성해서 반환하므로, 프론트엔드에서는 추가 확장이 필요 없음
        // 백엔드가 반환한 모든 이벤트를 그대로 사용
        const expandedEvents = mapped;

        // 일간 달력인 경우 현재 날짜에 해당하는 일정만 필터링
        let filteredMapped = expandedEvents;
        if (options?.viewMode === 'day' && options?.currentDate) {
          const currentDay = dayjs(options.currentDate).startOf('day');
          filteredMapped = expandedEvents.filter((ev) => {
            const evStart = dayjs(ev.start || ev.startDt || ev.START_DT);
            const evEnd = dayjs(ev.end || ev.endDt || ev.END_DT);

            if (!evStart.isValid() || !evEnd.isValid()) {
              return false;
            }

            // 일정이 현재 날짜와 겹치는지 확인
            return (
              evStart.isSame(currentDay, 'day') ||
              evEnd.isSame(currentDay, 'day') ||
              (evStart.isBefore(currentDay) && evEnd.isAfter(currentDay))
            );
          });
        }

        // 최종 중복 제거: 같은 calEId와 START_DT, END_DT, calId를 가진 일정은 한 번만 포함
        // 체크 해제된 캘린더의 일정이 남아있지 않도록 명확하게 필터링
        // 첫 번째 필터링에서 이미 체크된 캘린더만 포함했으므로, 여기서는 최신 캘린더 상태로 다시 확인
        const finalEventMap = new Map();

        // 최신 캘린더 상태에서 체크된 캘린더 ID 목록 생성
        const latestCheckedMyCalIds = new Set();
        calendarsToUse.myCalendars.forEach((cal) => {
          if (cal.checked === true && cal.calId) {
            latestCheckedMyCalIds.add(String(cal.calId));
          }
        });

        const latestCheckedSharedCalIds = new Set();
        calendarsToUse.sharedCalendars.forEach((cal) => {
          if (cal.checked === true) {
            const calId = String(
              cal.calId || cal.ownerCalId || cal.calMId || ''
            );
            if (
              calId &&
              calId !== 'undefined' &&
              calId !== 'null' &&
              calId !== ''
            ) {
              latestCheckedSharedCalIds.add(calId);
              if (cal.calMId) {
                latestCheckedSharedCalIds.add(String(cal.calMId));
              }
            }
          }
        });

        // 모든 캘린더가 체크 해제되었으면 빈 배열 반환
        if (
          latestCheckedMyCalIds.size === 0 &&
          latestCheckedSharedCalIds.size === 0
        ) {
          if (reqId === currentRequestIdRef.current) {
            setCalendarEvents([]);
            isSearchingRef.current = false;
          }
          return;
        }

        filteredMapped.forEach((event) => {
          const eventCalId = String(event.calId || '');
          // 체크된 캘린더의 일정인지 최신 상태로 다시 확인
          const isMyCalendar = latestCheckedMyCalIds.has(eventCalId);
          const isSharedCalendar = latestCheckedSharedCalIds.has(eventCalId);

          // 체크된 캘린더의 일정만 포함
          if (isMyCalendar || isSharedCalendar) {
            // 반복 일정 인스턴스의 경우 각 인스턴스마다 고유한 키 생성
            // startDt와 endDt를 포함하여 각 인스턴스를 구분
            const startDtStr =
              event.startDt ||
              (event.start
                ? dayjs(event.start).format('YYYY-MM-DD HH:mm:ss')
                : '');
            const endDtStr =
              event.endDt ||
              (event.end ? dayjs(event.end).format('YYYY-MM-DD HH:mm:ss') : '');
            const uniqueKey = `${event.calEId || ''}-${startDtStr}-${endDtStr}-${eventCalId}`;
            if (!finalEventMap.has(uniqueKey)) {
              finalEventMap.set(uniqueKey, event);
            }
          }
        });

        // 최신 요청의 응답만 상태 업데이트
        // 중복 제거되고 체크된 캘린더의 일정만 표시
        setCalendarEvents(Array.from(finalEventMap.values()));
      } catch (e) {
        // 최신 요청일 때만 에러 표시
        if (reqId === currentRequestIdRef.current) {
          dispatch(showSnackbar({ message: e.message, type: 'error' }));
        }
      } finally {
        if (reqId === currentRequestIdRef.current) {
          isSearchingRef.current = false;
        }
      }
    },
    // viewMode를 의존성에서 제거 (useRef로 관리하므로 불필요)
    [myCalendars, sharedCalendars, dispatch, userInfo.userid, validateSelection]
  );

  // SearchEventsLogic이 변경될 때마다 ref 업데이트
  useEffect(() => {
    searchEventsLogicRef.current = SearchEventsLogic;
  }, [SearchEventsLogic]);

  // Init 함수
  const Init = useCallback(async () => {
    // 1. 내 캘린더 조회 (내부에서 공유 캘린더도 조회됨)
    // 캘린더 데이터를 직접 받아서 일정 조회에 전달
    let myCalendarsData = [];
    let sharedCalendarsData = [];

    try {
      const result = await Search1();
      const apiRes1 = result.data;
      const isSuccess1 = apiRes1.isSuccess;
      const message1 = apiRes1.message;
      const severity1 = apiRes1.severity;
      const data = apiRes1.data;
      if (!isSuccess1) {
        setMyCalendars([]);
        setSharedCalendars([]);
        dispatch(
          showSnackbar({ message: message1, type: severity1 || 'error' })
        );
        return;
      }
      const rows1 = Array.isArray(data) ? data : [];
      if (!rows1.length) {
        setMyCalendars([]);
        setSharedCalendars([]);
        dispatch(
          showSnackbar({ message: message1, type: severity1 || 'info' })
        );
        return;
      }

      myCalendarsData = rows1.map((item) => ({
        calId: item.calId,
        description: item.description,
        color: item.color,
        isPublic: item.isPublic,
        ownerId: item.ownerId,
        mainCalendar: item.mainCalendar,
        checked: item.isPublic === '0', //기본 공개캘린더에 체크
      }));
      setMyCalendars(myCalendarsData);

      // 공유 캘린더 조회 (직접 API 호출로 변경하여 완료 대기)
      try {
        const sharedResult = await Commons.Axios(
          'post',
          Global.base.useUrl + Global.urls.Calendar.getCalendarR3,
          {
            UserId: userInfo.userid || '',
          }
        );
        const sharedApiRes = sharedResult.data;
        const sharedData = sharedApiRes.data;
        const { isSuccess: sharedIsSuccess } = sharedApiRes;

        if (
          sharedIsSuccess &&
          Array.isArray(sharedData) &&
          sharedData.length > 0
        ) {
          sharedCalendarsData = sharedData.map((item) => ({
            id: item.calMId,
            name: item.name,
            color: item.color,
            calendarNm: item.calendarNm,
            checked: item.isPublic === '0',
            calId: item.ownerCalId,
            userId: item.userId,
            calMId: item.calMId,
            isWait: item.isWait,
          }));
        } else {
          sharedCalendarsData = [];
        }
        setSharedCalendars(sharedCalendarsData);
      } catch (sharedError) {
        console.error('공유 캘린더 조회 실패:', sharedError);
        sharedCalendarsData = [];
        setSharedCalendars([]);
      }
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
      // 에러 발생 시에도 빈 배열로 초기화
      sharedCalendarsData = [];
    }

    // 2. 일정 조회 (현재 viewMode와 currentDate 기준)
    let start, end;
    if (viewMode === 'month') {
      // 월간 뷰: 달력에 표시되는 전체 범위 (첫 주 월요일부터 마지막 주 일요일까지)
      // GenerateMonthCalendar와 동일한 범위 계산
      const startOfMonth = currentDate.startOf('month');
      const endOfMonth = currentDate.endOf('month');
      const startOfCalendar = startOfMonth.startOf('week');
      const endOfCalendar = endOfMonth.endOf('week');

      start = startOfCalendar.startOf('day');
      end = endOfCalendar.endOf('day');
    } else if (viewMode === 'week') {
      start = currentDate.startOf('week').startOf('day');
      end = currentDate
        .endOf('week')
        .startOf('day')
        .add(1, 'day')
        .subtract(1, 'second');
    } else {
      // 일간 달력: 날짜 범위를 확장하여 조회 (반복 일정 누락 방지)
      start = currentDate.startOf('day').subtract(1, 'day');
      end = currentDate.endOf('day').add(1, 'day');
    }

    // 초기 로딩 시 날짜 범위 저장
    prevDateRangeRef.current = `${viewMode}-${start.format('YYYY-MM-DD')}-${end.format('YYYY-MM-DD')}`;

    // 새 요청 ID로 조회 실행 (캘린더 데이터를 직접 전달)
    const newRequestId = ++currentRequestIdRef.current;
    await SearchEventsLogic(
      start,
      end,
      newRequestId,
      {
        myCalendars: myCalendarsData,
        sharedCalendars: sharedCalendarsData,
      },
      {
        viewMode: viewMode, // viewMode 전달
        currentDate: currentDate, // currentDate 전달
      }
    );

    // 초기 로딩 완료 표시
    isInitialLoadRef.current = false;
  }, [Search1, SearchEventsLogic, viewMode, currentDate, dispatch, userInfo]);

  useEffect(() => {
    Init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 3. useEffect 수정
  useEffect(() => {
    // 초기 로딩 중이면 건너뛰기 (Init에서 이미 조회함)
    if (isInitialLoadRef.current) {
      prevViewModeRef.current = viewMode;
      // 초기 로딩 시 날짜 범위 계산
      let start, end;
      if (viewMode === 'month') {
        start = currentDate.startOf('month').startOf('week').startOf('day');
        end = currentDate
          .endOf('month')
          .endOf('week')
          .startOf('day')
          .add(1, 'day')
          .subtract(1, 'second');
      } else if (viewMode === 'week') {
        start = currentDate.startOf('week').startOf('day');
        end = currentDate
          .endOf('week')
          .startOf('day')
          .add(1, 'day')
          .subtract(1, 'second');
      } else {
        start = currentDate.startOf('day');
        end = currentDate.startOf('day').add(1, 'day').subtract(1, 'second');
      }
      prevDateRangeRef.current = `${viewMode}-${start.format('YYYY-MM-DD')}-${end.format('YYYY-MM-DD')}`;
      return;
    }

    let start, end;
    if (viewMode === 'month') {
      start = currentDate.startOf('month').startOf('week').startOf('day');
      end = currentDate
        .endOf('month')
        .endOf('week')
        .startOf('day')
        .add(1, 'day')
        .subtract(1, 'second');
    } else if (viewMode === 'week') {
      start = currentDate.startOf('week').startOf('day');
      end = currentDate
        .endOf('week')
        .startOf('day')
        .add(1, 'day')
        .subtract(1, 'second');
    } else {
      // 일간 달력: 날짜 범위를 확장하여 조회 (반복 일정 누락 방지)
      start = currentDate.startOf('day').subtract(1, 'day');
      end = currentDate.endOf('day').add(1, 'day');
    }

    // 날짜 범위를 문자열로 변환하여 중복 호출 방지
    const dateRangeStr = `${viewMode}-${start.format('YYYY-MM-DD')}-${end.format('YYYY-MM-DD')}`;

    // 동일한 조회 조건이면 중복 호출 방지
    if (prevDateRangeRef.current === dateRangeStr) {
      return;
    }

    // 새 요청 ID를 먼저 생성하여 이전 요청을 취소
    // 이렇게 하면 이전 요청의 응답이 나중에 도착해도 무시됨
    const newRequestId = ++currentRequestIdRef.current;

    // 조회 전에 ref 업데이트 (중복 호출 방지)
    // 요청 ID를 먼저 생성한 후에 ref 업데이트하여
    // 이전 요청이 완료되기 전에 새 요청이 시작되는 것을 방지
    prevViewModeRef.current = viewMode;
    prevDateRangeRef.current = dateRangeStr;

    // ref를 통해 최신 함수 호출
    // newRequestId를 전달하여 SearchEventsLogic 내부에서 이 ID를 사용하도록 함
    if (searchEventsLogicRef.current) {
      searchEventsLogicRef.current(start, end, newRequestId, null, {
        viewMode: viewMode,
        currentDate: currentDate,
      });
    }
    // searchEventsLogicRef는 ref 객체이므로 의존성 배열에 포함하지 않음
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewMode, currentDate]);
  //#endregion

  //#region 공유 캘린더 공유자 조회
  const HandleSupplierSearch = async () => {
    if (!validateSelection()) return;

    try {
      Search4({ userInfo, searchKeyword });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  //#region 공유자선택팝업에서 공유자 선택 완료 함수
  const HandleSupplierSelection = async () => {
    if (selectedSuppliers.length === 0) {
      dispatch(
        showSnackbar({ message: '공유자를 선택해주세요.', type: 'warning' })
      );
      return;
    }

    // 이미 추가된 캘린더의 calId 목록 (전체 기준으로 중복 체크)
    const existingCalIds = new Set();
    sharedCalendars.forEach((item) => {
      // calId가 있는 경우 추가
      const calId = String(item.calId || item.OWNER_calId || '');
      if (calId && calId !== 'undefined' && calId !== 'null' && calId !== '') {
        existingCalIds.add(calId);
      }
    });

    // 각 공유자의 캘린더 정보 조회 및 새 캘린더 필터링
    let totalNewCalendars = 0;
    let noCalendarSuppliers = []; // 캘린더가 없는 공유자 목록
    const savePromises = [];

    for (const supplier of selectedSuppliers) {
      try {
        // 공유자의 캘린더 calId 조회
        const supplierCalendarData = await SearchSupplierCalendarLogic(
          supplier.userId
        );

        if (!supplierCalendarData || supplierCalendarData.length === 0) {
          // 공유자에게 공유 가능한 캘린더가 없는 경우
          noCalendarSuppliers.push(supplier.name);
          continue;
        }

        // 새로운 calId를 가진 캘린더만 필터링
        const newCalendars = supplierCalendarData.filter((calendar) => {
          const calId = String(calendar.calId || '');
          return (
            calId &&
            calId !== 'undefined' &&
            calId !== 'null' &&
            calId !== '' &&
            !existingCalIds.has(calId)
          );
        });

        if (newCalendars.length > 0) {
          totalNewCalendars += newCalendars.length;

          // 새로운 캘린더들을 저장
          const calendarSavePromises = newCalendars.map(
            async (supplierCalendar) => {
              const saveSuccess = await SaveSupplierToCalendar({
                calMId: supplierCalendar.calMId || 0,
                calId: supplierCalendar.calId || 0,
                userId: supplier.userId,
                color: supplierCalendar.color,
                name: supplier.name,
              });

              return saveSuccess;
            }
          );

          savePromises.push(...calendarSavePromises);
        }
      } catch (error) {
        console.error(`${supplier.name} 캘린더 조회 실패:`, error);
      }
    }

    // 모든 SaveSupplierToCalendar 작업이 완료될 때까지 기다립니다.
    const results = await Promise.all(savePromises);

    const successCount = results.filter((r) => r === true).length;

    // 공유 캘린더 목록 다시 조회
    await SearchSharedCalendarLogic();

    // 결과 메시지 표시
    if (noCalendarSuppliers.length > 0 && totalNewCalendars === 0) {
      // 선택한 공유자 중 공유 가능한 캘린더가 없는 경우
      dispatch(
        showSnackbar({
          message: `선택한 공유자에게 공유 가능한 캘린더가 없습니다.`,
          type: 'warning',
        })
      );
    } else if (totalNewCalendars === 0) {
      dispatch(
        showSnackbar({
          message: '이미 선택된 공유자의 모든 캘린더가 추가되어 있습니다.',
          type: 'warning',
        })
      );
    } else {
      let message = `${successCount}/${totalNewCalendars}개의 캘린더가 신청대기로 추가되었습니다.`;
      if (noCalendarSuppliers.length > 0) {
        message += ` (${noCalendarSuppliers.join(', ')}님은 공유 가능한 캘린더가 없습니다.)`;
      }
      dispatch(
        showSnackbar({
          message,
          type: successCount === totalNewCalendars ? 'success' : 'warning',
        })
      );
    }

    // 팝업 닫기 및 선택 초기화
    setSupplierPopupOpen(false);
    setSelectedSuppliers([]);
  };
  //#endregion

  // 공유자의 캘린더 조회 함수 추가
  const SearchSupplierCalendarLogic = async (userId) => {
    if (!validateSelection()) return [];

    return new Promise((resolve) => {
      Search5(
        { userId },
        {
          onSuccess: (rows) => {
            const mappedData = rows.map((item) => ({
              calId: item.calId,
              calMId: item.calMId,
              description: item.description,
              color: item.color,
              isPublic: item.isPublic,
              ownerId: item.ownerId || userId,
            }));
            resolve(mappedData);
          },
          onError: () => {
            resolve([]);
          },
        }
      );
    });
  };
  //#region 공유캘린더 삭제
  // 공유캘린더 삭제 함수
  const DeleteSharedCalendarLogic = async (sharedCalendarIds) => {
    if (!validateSelection()) return;

    // sharedCalendarIds 안전하게 배열로 변환
    let idsArray = [];
    try {
      if (Array.isArray(sharedCalendarIds)) {
        idsArray = sharedCalendarIds;
      } else if (sharedCalendarIds) {
        idsArray = [sharedCalendarIds];
      }
    } catch (e) {
      dispatch(
        showSnackbar({
          message: '삭제할 공유캘린더 ID가 유효하지 않습니다.',
          type: 'error',
        })
      );
      return;
    }

    if (idsArray.length === 0) {
      dispatch(
        showSnackbar({
          message: '삭제할 공유캘린더가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    try {
      const results = await Promise.all(
        idsArray.map((id) => {
          const calMId = id.calMId || id;
          return Delete2Async([{ calMId: String(calMId) }]);
        })
      );
      let successCount = 0;
      let errorCount = 0;

      results.forEach((result) => {
        if (result?.severity === 'error') {
          errorCount++;
        } else {
          successCount++;
        }
      });

      if (successCount > 0 && errorCount === 0) {
        dispatch(
          showSnackbar({
            message: `${successCount}개의 공유캘린더가 삭제되었습니다.`,
            type: 'success',
          })
        );
        await SearchSharedCalendarLogic();
      } else if (successCount > 0 && errorCount > 0) {
        dispatch(
          showSnackbar({
            message: `${successCount}개 삭제 성공, ${errorCount}개 삭제 실패`,
            type: 'warning',
          })
        );
        await SearchSharedCalendarLogic();
      } else {
        dispatch(
          showSnackbar({
            message: '공유캘린더 삭제에 실패했습니다.',
            type: 'error',
          })
        );
      }
    } catch (e) {
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };
  //#endregion

  //#region 일정 등록
  const SaveScheduleLogic = async (scheduleForm, repeatSettings) => {
    if (!validateSelection()) return false;

    // 필수 필드 검증
    if (!scheduleForm.title?.trim()) {
      dispatch(
        showSnackbar({
          message: '일정 제목을 입력해주세요.',
          type: 'warning',
        })
      );
      return false;
    }

    if (!scheduleForm.calendarId) {
      dispatch(
        showSnackbar({
          message: '캘린더를 선택해주세요.',
          type: 'warning',
        })
      );
      return false;
    }

    try {
      // 반복 설정 데이터 준비 (반복이든 아니든 모든 파라미터 전송)
      let recurrenceData = {};
      const endType = (repeatSettings?.endType || '').toUpperCase();
      const untilDateStr =
        endType === 'UNTIL' && repeatSettings?.endDate
          ? dayjs(repeatSettings.endDate).format('YYYY-MM-DD')
          : null;

      if (scheduleForm.isRepeat && repeatSettings) {
        // 반복 설정이 있는 경우
        // 매월 반복의 경우 monthlyType에 따라 BY_MONTH_DAY 설정
        let byMonthDay = '0';
        if (repeatSettings.type === 'monthly') {
          if (repeatSettings.monthlyType === 'day') {
            // 특정 일자 선택 (예: 매월 15일)
            byMonthDay = String(repeatSettings.dayOfMonth || 0);
          } else if (repeatSettings.monthlyType === 'weekday') {
            // 특정 요일 선택 (예: 매월 첫 번째 월요일)
            // weekday인 경우에도 dayOfMonth가 설정되어 있으므로 사용
            // (RadioGroup onChange에서 dayOfMonth를 설정함)
            byMonthDay = String(repeatSettings.dayOfMonth || 0);
          } else {
            // monthlyType이 설정되지 않은 경우 기본값
            byMonthDay = String(repeatSettings.dayOfMonth || 0);
          }
        } else {
          // 매월이 아닌 경우
          byMonthDay = String(repeatSettings.dayOfMonth || 0);
        }

        recurrenceData = {
          RecurrenceType: (repeatSettings.type || '').toUpperCase(),
          RecurrenceInterval: String(repeatSettings.interval || 0),
          ByWeekDay: (repeatSettings.daysOfWeek || [])
            .map((d) => ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'][d])
            .join(','),
          ByMonthDay: byMonthDay,
          RruleEndType: endType,
          RecurrenceCount: String(
            endType === 'COUNT' ? repeatSettings?.endCount || 0 : 0
          ),
          RecurrenceUntil: untilDateStr || null,
        };
      } else {
        // 반복이 아닌 경우에도 모든 파라미터를 기본값으로 전송
        recurrenceData = {
          RecurrenceType: null,
          RecurrenceInterval: '0',
          ByWeekDay: null,
          ByMonthDay: '0',
          RruleEndType: null,
          RecurrenceCount: '0',
          RecurrenceUntil: null,
        };
      }

      // 알람 설정 데이터 준비
      // 알람이 설정되지 않았거나 비어있으면 null로 설정 (프로시저에서 IS NOT NULL 체크를 통과하지 않도록)
      const alarmMinutes =
        scheduleForm.alarmYn &&
        scheduleForm.alarms?.length > 0 &&
        scheduleForm.alarms.some((alarm) => alarm.minutes > 0)
          ? Math.min(
              ...scheduleForm.alarms
                .filter((alarm) => alarm.minutes > 0)
                .map((alarm) => {
                  switch (alarm.type) {
                    case 'minutes':
                      return alarm.minutes;
                    case 'hours':
                      return alarm.minutes * 60;
                    case 'days':
                      return alarm.minutes * 60 * 24;
                    case 'weeks':
                      return alarm.minutes * 60 * 24 * 7;
                    default:
                      return alarm.minutes;
                  }
                })
            )
          : null;

      // 날짜 유효성 검증
      const startDate = dayjs(scheduleForm.startDate);
      const endDate = dayjs(scheduleForm.endDate);

      if (!startDate.isValid()) {
        dispatch(
          showSnackbar({
            message: '시작 날짜가 유효하지 않습니다.',
            type: 'error',
          })
        );
        return false;
      }

      if (!endDate.isValid()) {
        dispatch(
          showSnackbar({
            message: '종료 날짜가 유효하지 않습니다.',
            type: 'error',
          })
        );
        return false;
      }

      // 종일일 경우 날짜만 사용하고 시간은 00:00:00으로 설정 (시작일과 종료일 모두)
      // 종일이 아닌 경우 시간 정보가 있는지 확인하고, 없으면 기본 시간 설정
      let startStr;
      let endStr;

      if (scheduleForm.isAllDay) {
        startStr = startDate.format('YYYY-MM-DD') + ' 00:00:00';
        endStr = endDate.format('YYYY-MM-DD') + ' 23:59:59';
      } else {
        // 종일이 아닌 경우 시간 정보 확인
        // startDate와 endDate가 시간 정보를 포함하는지 확인
        const startTimeStr = startDate.format('HH:mm:ss');
        const endTimeStr = endDate.format('HH:mm:ss');

        // 시간 정보가 모두 00:00:00이면 기본 시간 설정 (09:00:00, 10:00:00)
        if (startTimeStr === '00:00:00') {
          startStr = startDate
            .hour(9)
            .minute(0)
            .second(0)
            .format('YYYY-MM-DD HH:mm:ss');
        } else {
          startStr = startDate.format('YYYY-MM-DD HH:mm:ss');
        }

        if (endTimeStr === '00:00:00' || endTimeStr === '23:59:59') {
          // 종료 시간은 시작 시간 + 1시간
          const startTime = dayjs(startStr);
          endStr = endDate
            .hour(startTime.hour() + 1)
            .minute(startTime.minute())
            .second(0)
            .format('YYYY-MM-DD HH:mm:ss');
        } else {
          endStr = endDate.format('YYYY-MM-DD HH:mm:ss');
        }

        // 종료 시간이 시작 시간보다 이전이거나 같으면 종료 시간을 시작 시간 + 1시간으로 설정
        const startTime = dayjs(startStr);
        const endTime = dayjs(endStr);
        if (endTime.isBefore(startTime) || endTime.isSame(startTime)) {
          endStr = startTime.add(1, 'hour').format('YYYY-MM-DD HH:mm:ss');
        }
      }

      // 신규 일정인지 확인: calEId가 0, '', null, undefined인 경우 신규
      const calEidStr =
        scheduleForm?.calEId != null &&
        scheduleForm.calEId !== '' &&
        scheduleForm.calEId !== 0 &&
        scheduleForm.calEId !== '0'
          ? scheduleForm.calEId.toString()
          : '0';

      const calREidStr =
        scheduleForm?.calReId != null && scheduleForm.calReId !== ''
          ? scheduleForm.calReId.toString()
          : '0';

      const alarmMinutesBeforeStr =
        alarmMinutes !== null && alarmMinutes !== undefined && alarmMinutes > 0
          ? String(alarmMinutes)
          : null;

      const saveData = {
        calId: scheduleForm.calendarId,
        calEId: calEidStr,
        title: scheduleForm.title || '',
        description: scheduleForm.description || '',
        location: scheduleForm.location || '',
        startDate: dayjs(startStr),
        endDate: dayjs(endStr),
        isAllDay: scheduleForm.isAllDay,
        isCancelled: 'N',
        isPrivate: scheduleForm.isPrivate,
        calReId: calREidStr,
        RecurrenceType: recurrenceData.RecurrenceType,
        RecurrenceInterval: recurrenceData.RecurrenceInterval,
        ByWeekDay: recurrenceData.ByWeekDay,
        ByMonthDay: recurrenceData.ByMonthDay,
        RruleEndType: recurrenceData.RruleEndType,
        RecurrenceCount: recurrenceData.RecurrenceCount,
        RecurrenceUntil: recurrenceData.RecurrenceUntil,
        AlarmMinutesBefore: alarmMinutesBeforeStr,
      };

      const result = await Save1Async([saveData], {
        userInfo,
        startDate: dayjs(startStr),
        endDate: dayjs(endStr),
      });

      // 백엔드가 배열을 반환하므로 배열인지 확인
      const resultArray = Array.isArray(result) ? result : [result];
      const firstResult = resultArray[0];

      if (
        firstResult &&
        firstResult.severity !== 'error' &&
        firstResult.isSuccess !== false
      ) {
        dispatch(
          showSnackbar({
            message: firstResult.message || '일정이 등록되었습니다.',
            type: 'success',
          })
        );
        setScheduleDetailPopupOpen(false);
        RefreshEventsByView();
        return true;
      } else {
        dispatch(
          showSnackbar({
            message:
              firstResult?.message ||
              firstResult?.errorMsg ||
              '일정 등록에 실패했습니다.',
            type: 'error',
          })
        );
        return false;
      }
    } catch (e) {
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
      return false;
    }
  };
  //#endregion

  //#region 일정 삭제
  // 일정 삭제 함수 (SP_CALENDARS_D1 프로시저 사용)
  const DeleteScheduleLogic = async (calEId) => {
    if (!validateSelection()) return false;
    if (!calEId) {
      dispatch(
        showSnackbar({
          message: '삭제할 일정 정보가 없습니다.',
          type: 'warning',
        })
      );
      return false;
    }

    try {
      const result = await Delete3Async([{ calEId: String(calEId) }], {
        userInfo,
      });

      if (result && result.severity !== 'error') {
        dispatch(
          showSnackbar({
            message: '일정이 삭제되었습니다.',
            type: 'success',
          })
        );
        RefreshEventsByView();
        setScheduleDetailPopupOpen(false);
        ResetScheduleForm();
        return true;
      } else {
        dispatch(
          showSnackbar({
            message: result?.message || '일정 삭제에 실패했습니다.',
            type: 'error',
          })
        );
        return false;
      }
    } catch (e) {
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
      return false;
    }
  };

  const ResetScheduleForm = () => {
    setScheduleForm({
      title: '',
      description: '',
      location: '',
      isPrivate: false,
      calendarId: '',
      calEId: '',
      calReId: '',
      startDate: dayjs(),
      endDate: dayjs().add(1, 'hour'),
      isAllDay: false,
      isRepeat: false,
      alarmYn: false,
      alarms: [],
    });
  };
  //#endregion

  //#region 나머지 함수
  //+버튼 , 수정 클릭 이벤트
  const PopupClickEvent1 = (_data) => {
    let splitTime = [];
    if (
      !_data.data.alarmTime ||
      _data.data.alarmTime === undefined ||
      _data.data.alarmTime === ''
    ) {
    } else {
      splitTime = _data.data.alarmTime.split('-');
      setModalInputs({
        ...modalInputs,
        startTime: splitTime[0],
        endTime: splitTime[1],
      });
    }

    setClickRowId(_data.node.id);
    setModalToggle1(true);
  };

  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };
  const handleRowSelection = (rowData, rowIndex) => {
    currentRowIndexRef.current = rowIndex;
    setSelectedRowData1([rowData]);
  };
  //#endregion

  return (
    <div className="wrap">
      <SCH_BASIC
        userInfo={userInfo}
        lanInfo={lanInfo}
        menuInfo={menuInfo}
        rowData1={rowData1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        dialog={dialog}
        setDialog={setDialog}
        codeList={codeList}
        setCodeList={setCodeList}
        modalToggle1={modalToggle1}
        setModalToggle1={setModalToggle1}
        modalToggle2={modalToggle2}
        setModalToggle2={setModalToggle2}
        modalInputs={modalInputs}
        setModalInputs={setModalInputs}
        calendarManagementTab={calendarManagementTab}
        setCalendarManagementTab={setCalendarManagementTab}
        favoriteCalendarView={favoriteCalendarView}
        setFavoriteCalendarView={setFavoriteCalendarView}
        calendarManagementData={calendarManagementData}
        setCalendarManagementData={setCalendarManagementData}
        selectedCalendarManagementRows={selectedCalendarManagementRows}
        setSelectedCalendarManagementRows={setSelectedCalendarManagementRows}
        SearchCalendarManagementData={SearchCalendarManagementData}
        DeleteCalendarManagementData={DeleteCalendarManagementData}
        AcceptCalendarManagementData={AcceptCalendarManagementData}
        clickRowId={clickRowId}
        setClickRowId={setClickRowId}
        searchRef={searchRef}
        gridRef={gridRef1}
        selectedRowNosRef={selectedRowNosRef}
        lastCheckedIndexRef={lastCheckedIndexRef}
        deletedRowData1={deletedRowData1}
        // 회사, 사업장 관련 props
        handleCoChange={handleCoChange}
        handleCustChange={handleCustChange}
        validateSelection={validateSelection}
        // 날짜 관련 props
        startDate={startDate}
        endDate={endDate}
        handleStartDateChange={handleStartDateChange}
        handleEndDateChange={handleEndDateChange}
        // 함수
        PopupClickEvent1={PopupClickEvent1}
        NewYnErrorMsg={NewYnErrorMsg}
        handleRowSelection={handleRowSelection}
        updateCurrentRowData={updateCurrentRowData}
        // 캘린더 관련 props
        myCalendars={myCalendars}
        setMyCalendars={setMyCalendars}
        calendarForm={calendarForm}
        setCalendarForm={setCalendarForm}
        editingCalendar={editingCalendar}
        setEditingCalendar={setEditingCalendar}
        SaveCalendarLogic={SaveCalendarLogic}
        DeleteCalendarLogic={DeleteCalendarLogic}
        UpdateCalendarPublicLogic={UpdateCalendarPublicLogic}
        colorPickerOpen={colorPickerOpen}
        setColorPickerOpen={setColorPickerOpen}
        colorPalette={colorPalette}
        // 달력 뷰 관련 props
        viewMode={viewMode}
        setViewMode={setViewMode}
        currentDate={currentDate}
        setCurrentDate={setCurrentDate}
        // 공유 캘린더 관련 props
        sharedCalendars={sharedCalendars}
        setSharedCalendars={setSharedCalendars}
        UpdateSharedCalendarPublicLogic={UpdateSharedCalendarPublicLogic}
        // 팝업 상태 props
        calendarPopupOpen={calendarPopupOpen}
        setCalendarPopupOpen={setCalendarPopupOpen}
        supplierPopupOpen={supplierPopupOpen}
        setSupplierPopupOpen={setSupplierPopupOpen}
        scheduleDetailPopupOpen={scheduleDetailPopupOpen}
        setScheduleDetailPopupOpen={setScheduleDetailPopupOpen}
        repeatSettingsPopupOpen={repeatSettingsPopupOpen}
        setRepeatSettingsPopupOpen={setRepeatSettingsPopupOpen}
        moreEventsPopupOpen={moreEventsPopupOpen}
        setMoreEventsPopupOpen={setMoreEventsPopupOpen}
        moreEventsData={moreEventsData}
        setMoreEventsData={setMoreEventsData}
        deleteConfirmOpen={deleteConfirmOpen}
        setDeleteConfirmOpen={setDeleteConfirmOpen}
        calendarManagementConfirmOpen={calendarManagementConfirmOpen}
        setCalendarManagementConfirmOpen={setCalendarManagementConfirmOpen}
        calendarManagementConfirmAction={calendarManagementConfirmAction}
        setCalendarManagementConfirmAction={setCalendarManagementConfirmAction}
        selectedSuppliers={selectedSuppliers}
        setSelectedSuppliers={setSelectedSuppliers}
        isEditMode={isEditMode}
        setIsEditMode={setIsEditMode}
        pendingDeleteCalendars={pendingDeleteCalendars}
        setPendingDeleteCalendars={setPendingDeleteCalendars}
        // 일정 폼 관련 props
        scheduleForm={scheduleForm}
        setScheduleForm={setScheduleForm}
        // 반복 설정 관련 props
        repeatSettings={repeatSettings}
        setRepeatSettings={setRepeatSettings}
        // 공유 캘린더 관련 props
        suppliers={suppliers}
        setSuppliers={setSuppliers}
        supplierGridData={supplierGridData}
        setSupplierGridData={setSupplierGridData}
        HandleSupplierSearch={HandleSupplierSearch}
        HandleSupplierSelection={HandleSupplierSelection}
        searchKeyword={searchKeyword}
        setSearchKeyword={setSearchKeyword}
        SearchCalendarLogic={SearchCalendarLogic}
        SaveSupplierToCalendar={SaveSupplierToCalendar}
        isSharedEditMode={isSharedEditMode}
        setIsSharedEditMode={setIsSharedEditMode}
        pendingDeleteSharedCalendars={pendingDeleteSharedCalendars}
        setPendingDeleteSharedCalendars={setPendingDeleteSharedCalendars}
        DeleteSharedCalendarLogic={DeleteSharedCalendarLogic}
        UpdateCalendarColorLogic={UpdateCalendarColorLogic}
        UpdateCalendarDescriptionLogic={UpdateCalendarDescriptionLogic}
        UpdateSharedCalendarColorLogic={UpdateSharedCalendarColorLogic}
        SaveScheduleLogic={SaveScheduleLogic}
        DeleteScheduleLogic={DeleteScheduleLogic}
        calendarEvents={calendarEvents}
        getHolidayForDate={getHolidayForDate}
      />
      <Loading open={loading} />
    </div>
  );
}

export default SCH_BASICFunction;
